import React from 'react';
import {Button} from "reactstrap";
import Icon from "./../icon/FAIcon";
import classNames from 'classnames';

export default class TagItem extends React.Component {
    static PropTypes = {
        className: React.PropTypes.string,
        onRemove: React.PropTypes.func.isRequired,
    };

    render() {
        let {onRemove, children, className, ...otherProps} = this.props;

        className = classNames('tag-item', className);

        return (
            <div className={className} {...otherProps}>
                <div className="tag-content">
                    {children}
                </div>
                <Button type="button" className="tag-action" color="action" onClick={onRemove}><Icon icon="times"/></Button>
            </div>
        );
    }
}

